import React from 'react'
import PropTypes from 'prop-types'

const NewItemOverlay = ({ startDate, daysOffBeingNew, children }) => {
  const currentDate = new Date()
  const parsedStartDate = new Date(startDate)
  const timeDifference = currentDate.getTime() - parsedStartDate.getTime()
  const daysDifference = timeDifference / (1000 * 3600 * 24)
  const isNew = daysDifference < daysOffBeingNew

  return (
    <div className={'new-fabric-overlay-container'}>
      <div
        className={`new-fabric ${isNew ? 'new-fabric-isnew' : ''} ${children ? 'has-children' : 'has-no-children'}`}
      >
        <span>NEW</span>
      </div>
      {children && (
        <div className={`new-fabric-replacement ${isNew ? 'new-fabric-isnew' : ''}`}>
          {children}
        </div>
      )}
    </div>
  )
}

NewItemOverlay.propTypes = {
  startDate: PropTypes.string.isRequired,
  daysOffBeingNew: PropTypes.number.isRequired,
}

export default NewItemOverlay
